import React from "react";

// Material UI
import { Stack, Typography, TextField } from "@mui/material";

// Common
import { findPreviewDataValue } from "./MessageValues";

// Styles
import { textStyles } from "Common/Styles";

export const MessagePreview = ({
  formik,
  currentClient,
  formikValue,
  field,
  clinic,
}) => {
  const source = currentClient || formik.values;

  function renderPreview(template, lang) {
    return template.replace(/{{(\w+)}}/g, (_, key) =>
      findPreviewDataValue(key, lang, clinic)
    );
  }

  const PreviewTextField = ({ language, label }) => (
    <TextField
      name={`preview.${formikValue}.${field.id}.${language}`}
      id={`preview.${formikValue}.${field.id}.${language}`}
      value={renderPreview(
        source[formikValue][field.id]?.[language] || "",
        language
      )}
      label={label}
      variant="filled"
      disabled
      multiline
      rows={8}
      sx={{ width: "50%" }}
    />
  );

  return (
    <Stack spacing={1}>
      <Typography sx={textStyles.subtitle2}>Preview</Typography>
      <Stack direction="row" spacing={2} sx={{ mt: 1 }}>
        <PreviewTextField language="en" label="English Preview" />
        <PreviewTextField language="fr" label="French Preview" />
      </Stack>
    </Stack>
  );
};
